import type { IUniform, MeshStandardMaterial } from "three";
import CustomShaderMaterial from "three-custom-shader-material/vanilla";

import { ENGINE_UNIFORM_DECLARATIONS, engineUniforms } from "./engineUniforms";

// NOTE: the shader only overrides the outputs it sets (csm_Emissive, csm_DiffuseColor, ...) so the standard material's lighting and shadows still apply
//        this will allow for artists to utilize custom shaders for advanced looks similar to godot
export function withCustomShader(
  base: MeshStandardMaterial,
  fragmentShader: string,
  uniforms: Record<string, IUniform>
): CustomShaderMaterial {
  return new CustomShaderMaterial({
    baseMaterial: base.clone(),
    fragmentShader: ENGINE_UNIFORM_DECLARATIONS + fragmentShader,
    uniforms: { ...engineUniforms, ...uniforms }
  });
}
